import React, { useState, useEffect } from 'react';
import { WithStyles, withStyles } from '@mui/styles';
import { ClassNameMap } from '@mui/styles/withStyles';
import { withRouter, RouteComponentProps, useParams } from 'react-router-dom';

import { useQuery } from '@apollo/client';

import Dashboard from '../../../../../../layouts/Dashboard';
import ViewStation from '../../../../../../components/Global/Areas/Sections/Stations/View';
import { selectStationInitQuery, Station } from './queries';

import styles from './styles';

interface Props extends WithStyles<typeof styles>, RouteComponentProps {
  classes: ClassNameMap<string>;
}

interface UrlParams {
  area_id: string;
  section_id: string;
  station_id: string;
}

const ViewStationOrg = ({ classes, history }: Props): React.ReactElement => {
  const { area_id, section_id, station_id } = useParams<UrlParams>();

  const [station, setStation] = useState<Station>({
    name: '',
    area: {
      name: '',
    },
    section: {
      name: '',
    },
  });

  const { data: stationInitData } = useQuery(selectStationInitQuery(station_id), { fetchPolicy: 'no-cache' });

  useEffect(() => {
    let mounted = true;
    if (mounted && stationInitData) {
      setStation(stationInitData.area_section_stations_by_pk);
    }
    return () => {
      mounted = false;
    };
  }, [stationInitData]);

  const handleEdit = () => {
    history.push(`/trust/departments/${area_id}/wards/${section_id}/bed-spaces/${station_id}/edit`);
  };

  return (
    <Dashboard
      breadcrumbs={[
        { label: 'Departments', link: `/trust/departments` },
        { label: station.area.name, link: `/trust/departments/${area_id}` },
        { label: 'Wards', link: `/trust/departments/${area_id}/wards` },
        { label: station.section.name, link: `/trust/departments/${area_id}/wards/${section_id}` },
        { label: 'Bed spaces', link: `/trust/departments/${area_id}/wards/${section_id}/bed-spaces` },
        { label: station.name, link: `/trust/departments/${area_id}/wards/${section_id}/bed-spaces/${station_id}` },
      ]}>
      <ViewStation station_id={station_id} handleEdit={handleEdit} />
    </Dashboard>
  );
};

export default withRouter(withStyles(styles)(ViewStationOrg));
